import { css, useTheme, Global } from '@emotion/react';

export function GlobalStyles() {
	const theme = useTheme();

	return (
		<Global
			styles={css`
				* {
					margin: 0;
					padding: 0;
					outline: 0;
					box-sizing: border-box;
				}
				body {
					-webkit-font-smoothing: antialiased !important;
				}

				.disabled-row-table {
					background-color: #fafafa;
				}

				.ant-table {
					border-radius: 10px;
					.ant-table-thead {
						.ant-table-cell:first-child {
							border-radius: 10px 0 0 0;
						}
						.ant-table-cell:last-child {
							border-radius: 0 10px 0 0;
						}
					}
				}

				.ant-menu-item {
					span {
						display: inline !important;
					}
				}

				.kinebot-select-dropdown {
					padding: 0;
					border-radius: 4px;
					box-shadow: 2px 2px 8px 0px ${theme.palette.secondary['200']};

					.kinebot-select-item {
						border-radius: 0;
						padding: 0.5rem 1rem;
						color: ${theme.palette.secondary['500']} !important;
						font-size: ${theme.fonts.label.md.fontSize} !important;
						font-weight: ${theme.sizes.weights.regular} !important;
						line-height: ${theme.fonts.label.md.lineHeight} !important;
						letter-spacing: ${theme.fonts.label.md.letterSpacing} !important;

						&:not(:last-child, .kinebot-select-item-option-selected) {
							border-bottom: 1px solid ${theme.palette.secondary['150']} !important;
						}

						&:hover {
							background-color: ${theme.palette.secondary['100']} !important;
						}
					}

					.kinebot-select-item-option-selected {
						color: ${theme.colors.primary} !important;
						background-color: ${theme.palette.primary['100']} !important;

						&:not(:last-child) {
							border-bottom: 1px solid ${theme.palette.primary['200']} !important;
						}

						&:hover {
							background-color: ${theme.palette.primary['100']} !important;
						}
					}

					.rc-virtual-list-scrollbar {
						width: 4px !important;
						margin: 0.5rem 0.5rem 0 0 !important;
					}

					.rc-virtual-list-scrollbar-thumb {
						background-color: ${theme.palette.secondary['250']} !important;
					}
				}
			`}
		/>
	);
}
